import Vue from 'vue';
import Vuex from 'vuex';
import { Toast } from '@sdi/fish';

import { queryList, refund, queryListDone } from '@/api';
import { getApiMsg } from '@/utils';
import { KEY } from '@/consts';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {},
    orderList: [],
    orderListDone: {
      page: 1,
      items: [],
      total: 1
    }
  },
  mutations: {
    login(state, payload) {
      state.user = payload;
      state.orderList.length = 0;
      state.orderList = [];
    },
    updateOrderList(state, payload) {
      state.orderList = payload;
    },
    updateOrderListDone(state, payload) {
      state.orderListDone.items =
        payload.queryRefundedOrderResultPageList.items;
      state.orderListDone.total =
        payload.queryRefundedOrderResultPageList.numRows;
    }
  },
  actions: {
    login({ commit }, payload) {
      commit('login', payload);
    },
    async getOrderList({ commit, state }) {
      const resp = await queryList({
        certNo: state.user.id,
        name: state.user.username,
        corpCode: state.user[KEY]
      });
      if (+resp.data.code === 0) {
        commit('updateOrderList', resp.data.queryBillListResults);
      } else {
        Toast(getApiMsg(resp.data.desc) || '获取列表失败');
      }
    },
    async getOrderListDone({ commit, state }) {
      const resp = await queryListDone({
        certNo: state.user.id,
        name: state.user.username,
        corpCode: state.user[KEY]
      });
      if (+resp.data.code === 0) {
        commit('updateOrderListDone', resp.data);
      } else {
        Toast(getApiMsg(resp.data.desc) || '获取列表失败');
      }
    },
    async refund({ state }, payload) {
      const resp = await refund(
        payload.orderData,
        payload.form,
        state.user[KEY]
      );
      if (+resp.data.code === 0) {
        Toast('退款成功');
        return true;
      } else {
        Toast(getApiMsg(resp.data.desc) || '退款失败，请重试');
        return false;
      }
    }
  },
  getters: {
    user(state) {
      return state.user;
    },
    isLogin(state) {
      return !!state.user.id;
    },
    orderList(state) {
      return state.orderList;
    },
    orderListDone(state) {
      return state.orderListDone.items;
    },
    getOrderById: state => id => {
      return (
        state.orderList.find(order => order.billNo === id) ||
        state.orderListDone.items.find(order => order.billNo === id)
      );
    },
    getDoneFinished(state) {
      if (state.orderListDone.items.length >= state.orderListDone.total) {
        return true;
      } else {
        return false;
      }
    },
    isRefund: state => id => {
      return !!state.orderListDone.items.find(order => order.billNo === id);
    }
  }
});
